import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eaddc2e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth-code" }
const _hoisted_2 = {
  key: 1,
  class: "code"
}

import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { useTokenManager } from '@/auth/TokenManager'
import { useSignInStore } from './SignInStore'
import { DateTime, Duration } from 'luxon'
import CopyTextButton from '@/util/CopyTextButton.vue'

const expiringDuration = 60 * 1000 // 1 minute


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthCode',
  props: {
    alwaysShowTimer: { type: Boolean },
    autoRequest: { type: Boolean }
  },
  emits: [
  'authCodeUsed',
],
  setup(__props: any, { emit }) {

const props = __props;





const tokenManager = useTokenManager()
const signInStore = useSignInStore()

const remainingTimeRef = ref(0)
let timerHandle = 0

const isCodeExpiredRef = computed(() => signInStore.syncAppAuthCode && remainingTimeRef.value <= 0)
const showTimerRef = computed(() => signInStore.syncAppAuthCode && remainingTimeRef.value > 0 && (props.alwaysShowTimer || remainingTimeRef.value < expiringDuration))
const remainingTextRef = computed(() => {
  const d = Duration.fromMillis(remainingTimeRef.value)
  return d.as('minutes') >= 1 ? `${Math.ceil(d.as('minutes'))} min` : d.toFormat('m:ss')
})

watch(() => signInStore.syncAppAuthCodeUsed, () => {
  if (signInStore.syncAppAuthCodeUsed) {
    if (timerHandle) {
      clearInterval(timerHandle)
    }
    emit('authCodeUsed')
  }
})

onMounted(async () => {
  if (props.autoRequest) {
    await ensureCodeRequestedAsync()
  }
})

onUnmounted(() => {
  stopTimer()
})

async function ensureCodeRequestedAsync() {
  const token = await tokenManager.getAccessTokenAsync()
  if (token) {
    await signInStore.ensureAuthCodeRequestedAsync()
    updateRemainingTime()

    stopTimer() // just in case
    timerHandle = setInterval(() => {
      updateRemainingTime()
      if (remainingTimeRef.value == 0) {
        stopTimer()
      }
    }, 1000)
  }
}

function updateRemainingTime() {
  remainingTimeRef.value = Math.max(0, signInStore.syncAppAuthCode!.expirationDate.diff(DateTime.utc()).milliseconds)
}

function stopTimer() {
  if (timerHandle) {
    clearInterval(timerHandle)
    timerHandle = 0
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(signInStore).syncAppAuthCode || isCodeExpiredRef.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "btn btn-inline btn-link",
          onClick: ensureCodeRequestedAsync
        }, " Get a new code "))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(_unref(signInStore).syncAppAuthCode?.code) + " ", 1),
          _createVNode(CopyTextButton, {
            "copy-text": _unref(signInStore).syncAppAuthCode?.code
          }, null, 8, ["copy-text"])
        ])),
    _createElementVNode("div", {
      class: _normalizeClass(["remaining", { show: showTimerRef.value}])
    }, " Get a new code in " + _toDisplayString(remainingTextRef.value), 3)
  ]))
}
}

})